import React, { useRef, useState } from 'react'
import { authActions, loadingActions } from '../../redux/actions'
import { useDispatch } from 'react-redux'
import Input from '../../components/shared/Input'
import './Login.scss'
import Button from '../../components/shared/Button'
import Modal from '../../components/shared/Modal';
import accessAPI from '../../api/acesssAPI'
import Captcha from '../../components/shared/Captcha'

const Login = () => {
  const captchaRef = useRef(null)

  const dispatch = useDispatch()
  const [modalNoInternet, setModalNoInternet] = useState(false)
  const [modalError, setModalError] = useState(false)

  const [username, setUsername] = useState('cjimenez')
  const [password, setPassword] = useState('Ripleycj202110.$')
  const [recapchaToken, setRecapchaToken] = useState(null)

  const login = async () => {

    if (!recapchaToken) {
      return console.log('No validado')
    }

    try {
      dispatch(loadingActions.setLoading(true))
      const payload = {
        username,
        password,
        recapchaToken
      }
      const { userfullname:fullname, branchs, profile:profiles, token } = await accessAPI.login(payload)
      const stores = branchs.length > 0 ? branchs.map(b => ({ storeId: b.locationcode, storeName: b.locationname })) : []
      dispatch(loadingActions.setLoading(false))
      dispatch(authActions.login({ username, fullname, stores, profiles, token }))
    } catch(e) {
      dispatch(loadingActions.setLoading(false))
      if (captchaRef.current) {
        setRecapchaToken(null)
        captchaRef.current.props.grecaptcha.reset();
      }
      if(e?.response?.status === 400)
        setModalError(true)
      else
        setModalNoInternet(true)
    }
  }

  return (
    <div className='login-container'>
      <Modal
        visible={modalNoInternet}
        onClose={() => {}}
        title='No hay conexión'
        titleImage={require('../../../assets/icons/ic_disconnected.svg')}
        color='var(--ripley-salmon)'
        btn1={{
          text: 'Volver',
          type: 'secondary',
          onClick: () => {
            setModalNoInternet(false)
          }
        }}
        btn2={{
          text: 'Reintentar',
          type: 'primary',
          onClick: () => {
            setModalNoInternet(false)
            login()
          }
        }}
      >
        <div className='modal-error'>
          <p>Revisa tu conexión a internet e inténtalo de nuevo</p>
        </div>
      </Modal>
      <Modal
        visible={modalError}
        onClose={() => {}}
        title='Datos incorrectos'
        titleImage={require('../../../assets/icons/ic_alerta.svg')}
        color='var(--ripley-salmon)'
        btn1={{
          text: 'Volver',
          type: 'primary',
          onClick: () => {
            setModalError(false)
          }
        }}
      >
        <div className='modal-error'>
          <p>Usuario o contraseña incorrectos</p>
        </div>
      </Modal>
      <div className='login-form'>
        <img src={require('../../../assets/images/logo_app.svg')} alt='logo'/>
        <h1>Bienvenido/a de vuelta!</h1>
        <h2>Ingresa tus datos</h2>
        <div className='login-input-container'>
          <Input
            key='user'
            placeholder='Usuario'
            value={username}
            onChange={text => setUsername(text)}
            type='text'
          />
        </div>
        <div className='login-input-container'>
          <Input
            key='password'
            placeholder='Contraseña'
            value={password}
            onChange={text => setPassword(text)}
            type='password'
          />
        </div>

        <Captcha
          ref={captchaRef}
          onChange={setRecapchaToken}
          onExpired={() => setRecapchaToken(null)}
        />

        <div className='login-button-container'>
          <Button
            text='Iniciar sesión'
            type={'primary'}
            disabled={!username || !password || !recapchaToken}
            onClick={() => login()}
          />
        </div>
      </div>
    </div>
  )
}

export default Login
